import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";
import { StaggerGroup, fadeUp } from "@/components/motion/Reveal";
import Icon from "@/components/Icon";
import { WHY_CHOOSE } from "@/data/site";

export default function WhyChoose() {
  return (
    <section className="section-pad bg-white" data-testid="why-choose-section">
      <div className="container-sky">
        <SectionHeading
          align="center"
          eyebrow="Why SKY"
          title="Why Organisations Choose SKY"
          description="Practical, professional and focused on outcomes that work in your real operating environment."
          className="mb-14"
        />
        <StaggerGroup className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_CHOOSE.map((b) => (
            <motion.div
              key={b.title}
              variants={fadeUp()}
              className="group relative overflow-hidden rounded-2xl border border-slate-100 bg-surface p-8 transition-all duration-500 hover:border-brand/30 hover:shadow-[0_18px_48px_rgba(10,126,201,0.12)]"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-brand shadow-sm transition-all duration-500 group-hover:bg-brand group-hover:text-white">
                <Icon name={b.icon} className="h-7 w-7" />
              </span>
              <h3 className="mt-6 font-heading text-lg font-bold text-navy">{b.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{b.description}</p>
              <svg className="pointer-events-none absolute -bottom-4 -right-4 h-24 w-24 text-brand/5 transition-transform duration-500 group-hover:scale-110" viewBox="0 0 100 100" fill="none">
                <path d="M15 75 Q55 70 80 25 M80 25 H55 M80 25 V50" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
